import { Dispatch, RefObject, SetStateAction, useCallback } from 'react';

import styles from '../../../custom-select.module.css';

const useHandleFocus = ({
  menuRef,
  setIsFocused,
  setMenuOpen,
}: {
  menuRef: RefObject<HTMLDivElement | null>;
  setIsFocused: Dispatch<SetStateAction<boolean>>;
  setMenuOpen: Dispatch<SetStateAction<boolean>>;
}) => {
  return useCallback(() => {
    setIsFocused(true);

    // settimeout required to allow classes to catch up before checking
    setTimeout(() => {
      const menuOpen = menuRef.current?.classList.contains(styles['menu-open']);
      if (!menuOpen) {
        setMenuOpen(true);
      }
    }, 0);
  }, [menuRef, setIsFocused, setMenuOpen]);
};

export default useHandleFocus;
